import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RouterUtilitiesService {
  private readonly router = inject(Router);

  public getRouterState(): Record<string, unknown> | undefined {
    const state: Record<string, unknown> | undefined = this.router.getCurrentNavigation()?.extras.state as
      | Record<string, unknown>
      | undefined;
    const effectiveState: Record<string, unknown> | undefined = state ?? (history.state as Record<string, unknown>);

    return effectiveState;
  }
}
